import React from 'react';
import PropTypes from 'prop-types';
import DownloadArrowGREEN from '../../../../../../static/images/DownloadArrow-GREEN.svg';
import DeleteXRed from '../../../../../../static/images/DeleteX-Red.svg';
import RecapORange from '../../../../../../static/images/Orange-Recap.svg';
import BlackInvoice from '../../../../../../static/images/Black-Invoice.svg';

const DataExportOptions = props => (
  <div className='data-export-options'>
    <div className='delete clickable' onClick={props.handleDeleteClick}>
      <img className='options-icon' src={DeleteXRed} alt='delete' />
      <span className='text'>Delete</span>
    </div>
    {props.downloadClickable ? <div
      className='download clickable'
      onClick={props.handleDownload}
    >
      <img
        className='options-icon'
        src={DownloadArrowGREEN}
        alt='download'
      />
      <span
        className='text'
      >
          Download
      </span>
    </div> : null}
    {props.isCostClickable ? <div
      className='get-receipt clickable'
      onClick={props.handleReceiptClick}
    >
      <img
        className='options-icon'
        src={BlackInvoice}
        alt='go to data export receipt page'
      />
      <span
        className='text'
      >
          Get Receipt
      </span>
    </div> : null}
    <div
      className='recap clickable'
      onClick={props.handleRecap}
    >
      <img
        className='options-icon'
        src={RecapORange}
        alt='recap'
      />
      <span
        className='text'
      >
          Recap
      </span>
    </div>
  </div>
);

DataExportOptions.propTypes = {
  handleDeleteClick: PropTypes.func.isRequired,
  isCostClickable: PropTypes.bool,
  handleReceiptClick: PropTypes.func,
  handleDownload: PropTypes.func.isRequired,
  handleRecap: PropTypes.func.isRequired,
  downloadClickable: PropTypes.bool.isRequired,
};

export default DataExportOptions;



// WEBPACK FOOTER //
// ./modules/DataExports/components/home/children/children/options.js